import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "limit--sprite",
  "use": "limit--sprite-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"limit--sprite\">\n<path d=\"M10.0007 3.33333V8H6.00065V3.33333H10.0007ZM10.0007 2H6.00065C5.26732 2 4.66732 2.6 4.66732 3.33333V9.33333H11.334V3.33333C11.334 2.6 10.734 2 10.0007 2ZM14.6673 6.66667H12.6673V8.66667H14.6673V6.66667ZM3.33398 6.66667H1.33398V8.66667H3.33398V6.66667ZM13.334 10H2.66732V14H4.00065V11.3333H12.0007V14H13.334V10Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol